export const API_URL = 'http://localhost:8080';
